import { useAtomValue, useSetAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import { SegmentedControl } from '@/core/ui';
import { setAppModeAtom } from './actions';
import { appModeAtom } from './atoms';

export function AppModeToggle({ className }: { className?: string }) {
  const { t } = useTranslation('app');
  const mode = useAtomValue(appModeAtom);
  const setMode = useSetAtom(setAppModeAtom);
  return (
    <SegmentedControl
      className={className}
      options={[
        { value: 'forecast', label: t('mode.forecast') },
        { value: 'explore', label: t('mode.explore') },
      ]}
      value={mode}
      onChange={setMode}
    />
  );
}
